// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statistical-area-plugin-tooltip .mapboxgl-popup-tip{
  display: none;
}
.statistical-area-plugin-tooltip .mapboxgl-popup-content {
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/ls-map/src/map/plugins/statisticalAreaPlugin/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf","sourcesContent":[".statistical-area-plugin-tooltip .mapboxgl-popup-tip{\n  display: none;\n}\n.statistical-area-plugin-tooltip .mapboxgl-popup-content {\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
